// TODO: draft

import { useRef, useCallback } from 'react';
import constate from 'constate';
const SRC = 'storyboard-region.provider.ts';

import { RootState } from 'store/store';
import { useAppStore } from 'store/store-hooks';
import { useAudioTrackContext } from 'components/app/audio-track/_mediator/audio-track.provider';
import { getCursorCell } from 'components/app/editor/_mediator/editor-markers/editor-markers.helper';

const useSbRegionProvider = () => {
  const regionInId = useRef<ReturnType<typeof setTimeout>>();
  const regionOutId = useRef<ReturnType<typeof setTimeout>>();
  return { regionInId, regionOutId };
};
export const [SbRegionProvider, useSbRegionContext] = constate(useSbRegionProvider);

/* H O O K */

export const useSbRegion = () => {
  const { regionInId } = useSbRegionContext();
  const { ws } = useAudioTrackContext();
  const store = useAppStore();

  const regionInCb = (cell: Index) => {
    console.log('__new', { time: ws.current!.getCurrentTime(), cell });
  };

  const runRegionInListener = useCallback(() => {
    const { markers, duration } = selectData(store.getState());
    if (!ws.current || !markers || !duration) {
      console.log(`[${SRC}] runRegionInListener`);
      return;
    }
    if (ws.current.isPlaying()) return;
    clearTimeout(regionInId.current);
    const time = ws.current.getCurrentTime();
    const cell = getCursorCell(time, markers);
    const marker = markers[cell];
    if (marker === undefined) return;
    const timeToCellEnd = (marker - time) * 1000;
    const runTimeout = (timeToCellEnd: Milliseconds, cell: Index) => {
      regionInId.current = setTimeout(() => {
        cell++;
        regionInCb(cell);
        const time = ws.current!.getCurrentTime();
        const marker = markers[cell];
        if (marker === undefined) return;
        const timeToCellEnd = (marker - time) * 1000;
        runTimeout(timeToCellEnd, cell);
      }, timeToCellEnd);
    };
    runTimeout(timeToCellEnd, cell);
  }, []);

  const stopRegionInListener = useCallback(() => {
    clearTimeout(regionInId.current);
  }, []);

  return { runRegionInListener, stopRegionInListener };
};

/* S E L E C T O R S */

const selectData = (state: RootState) => {
  const { duration } = state.audio;
  const { markers, storyBoard } = state.editor;
  return { markers, duration, storyBoard };
};
